import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const PROGRAMS = [
  {
    id: "commissions",
    eyebrow: "Commission",
    title: "A painting,\nmade for you.",
    blurb:
      "Portraits of people, places, and moments — built from your story and finished in the studio's voice. Begin with a 20-minute scoping call.",
    image:
      "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/u8wgfmmj_last%20hope.JPG",
    to: "/commissions",
    cta: "Start a commission",
  },
  {
    id: "paint-n-sip",
    eyebrow: "Bob'Bae Rosé · Paint n Sip",
    title: "Loud laughter,\nsoft canvas.",
    blurb:
      "Two-hour Paint n Sip parties hosted in character by Bob'Bae Rosé — at the studio, in your home, or at the office. From $50 / person.",
    image:
      "https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/8mnl7b8f_IMG_5699.jpg",
    to: "/paint-n-sip",
    cta: "Explore Paint n Sip",
  },
];

export default function StudioPrograms() {
  return (
    <section
      className="border-t border-border bg-[hsl(var(--surface))]"
      data-testid="studio-programs"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <header className="mb-12 md:mb-16">
          <p className="label mb-3">Studio Programs</p>
          <h2 className="serif text-4xl md:text-5xl tracking-tight font-light leading-[1.05]">
            Beyond the catalog.
          </h2>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14">
          {PROGRAMS.map((p) => (
            <Link
              key={p.id}
              to={p.to}
              className="group block"
              data-testid={`studio-program-${p.id}`}
            >
              <div className="aspect-[4/5] overflow-hidden bg-background">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]"
                />
              </div>
              <div className="mt-6 flex items-start justify-between gap-6">
                <div className="flex-1">
                  <p className="label mb-3">{p.eyebrow}</p>
                  <h3 className="serif text-3xl md:text-4xl tracking-tight font-light leading-[1.1] whitespace-pre-line">
                    {p.title}
                  </h3>
                  <p className="mt-5 text-[hsl(var(--ink-soft))] leading-relaxed max-w-md">
                    {p.blurb}
                  </p>
                  <p className="mt-6 label flex items-center gap-2 group-hover:gap-3 transition-all">
                    {p.cta}
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
